import { ROUTE_NAME_CLAIM_CHARTING } from '@/constants';

export default {
    name: ROUTE_NAME_CLAIM_CHARTING,
    exclusiveRoutePath: '/claim-charting/:targetId\':sourceId',
    getComponent: () => import('./ClaimCharting.vue'),
    fullView: true,
};
